module.exports = __webpack_public_path__ + "media/images/assignment/publish-2a1c8be633f2e3abb3d2f7d6303e536f.svg";